import script from "./register.vue?vue&type=script&setup=true&lang=js"
export * from "./register.vue?vue&type=script&setup=true&lang=js"

import "./register.vue?vue&type=style&index=0&id=5dcc053e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dcc053e"]])

export default __exports__